import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-missing-meta-description',
    templateUrl: './missing-meta-description.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoMissingMetaDescriptionComponent {
}
